<template>
  <div
  style="padding:10px;"
  :class="
  !this.$store.getters.iframeColidee
  ? window.width > 400
  ? ''
  : ''
  : 'text-resize-colidee'
  "
  >
  <div>
    <div>
      <div v-if="validateButtons" style="text-align: right;margin:10px;">
        <button @click="cancelOrderedList" style="margin-right:5px;">
         {{$t("sondage.cancel")}}
       </button>
       <button @click="validateOrderedList" class="btn-primary">
        {{$t("sondage.registeredOrder")}}
      </button>
    </div>
    <draggable
    :list="meetings"
    draggable=".item"
    style="cursor:move;display:flex;flex-wrap:wrap;justify-content:center;"
    ghost-class="ghost"
    @change="showButtonsValidate"
    >
    <div
    v-for="(sondage, index) in meetings"
    :key="sondage.id"
    style="display: inline-block;"
    class="item"
    >
    <!-- cards list -->
    <div style="width:215px;margin:5px;" class=" card shadow-card">
      <img
      style="transform: rotate(90deg);display: block;margin-left: auto;margin-right: auto;"
      src="@/assets/img/icons/updown.png"
      />

      <!-- cards list -->
      <div
      ><div v-if="sondage.close_at != '1970-01-01 00:00:00' &&
      sondage.close_at != null &&
      new Date(sondage.open_at) > now" id="programmed-meeting">{{$t("sondage.programmed")}}</div>
      <div v-if="sondage.close_at != '1970-01-01 00:00:00' &&
      sondage.close_at != null &&
      new Date(sondage.close_at) < now" id="closed-meeting">{{$t("sondage.closed")}}</div>
      <div :class="!sondage.state ? 'state-closed' : ''">
        <div :style="background(sondage.media)"></div>
      </div>
      <div>
        <div class="media">
          <div class="media-content">
            <div style="margin-bottom:5px;text-align:center">
              <p
              :class="!sondage.state ? 'state-closed' : ''"
              style="position:absolute;top:175px;left:10px;"
              >
              {{
                sondage.created_at
                .substring(0, 10)
                .split("-")
                .reverse()
                .join("/")
              }}
            </p>
            <div
            style="display:flex;position:absolute;top:175px;right:10px;"
            >
            <WhoIsOwner :sondage="sondage" />
            <ParametersDropdown
            :cardIndex="index"
            :sondage="sondage"
            />
          </div>
          <p
          style="margin-top:20px;"
          :class="!sondage.state ? 'state-closed' : ''"
          >
          {{
            $tc("sondage.votes", sondage.results_count, {
              count: sondage.results_count
            })
          }}
        </p>
        <p
        :class="!sondage.state ? 'state-closed' : ''"
        style="font-size:13px; color:black; font-weight:bold"
        >
        {{ sondage.name }}
      </p>
      <p :class="!sondage.state ? 'state-closed' : ''">
        {{
          sondage.client !== null
          ? sondage.client
          : $t("sondage.inconnu")
        }}
      </p>
      <p :class="!sondage.state ? 'state-closed' : ''">
        {{
          sondage.evenement !== null
          ? sondage.evenement
          : $t("sondage.inconnu")
        }}
      </p>
    </div>
  </div>
</div>
</div>

<footer
:class="!sondage.state ? 'state-closed' : ''"
class="card-footer"
>
<button
@click="questions(sondage.id, sondage.name)"
:class="'card-footer-item button button-params'"
>
{{ $t("sondage.remplir") }}
</button>
<button
:disabled="sondage.elements_count === 0"
@click="
resultats(
  sondage.url_moderateur,
  sondage.id,
  sondage.name
  )
  "
  class="card-footer-item button button-params"
  >
  {{ $t("sondage.resultat") }}
</button>
</footer>
</div>
</div>
</div>
<AddSondageButton
style="min-width:215px;max-width:215px;height:140px;"
slot="header"
class="card shadow-card"
/>
</draggable>
</div>
<b-modal :width="640" v-model="modalQrCode.activeModalQrCode">
  <ModalQrCode :modalQrCode="modalQrCode" />
</b-modal>
<b-modal :width="640" v-model="modalShares.activeModalShares">
  <ModalShare :modalShares="modalShares"
  /></b-modal>
  <b-modal :width="640" v-model="modalDuplicate.activeModalDuplicate">
    <ModalDuplicate :modalDuplicate="modalDuplicate" />
  </b-modal>
  <b-modal
  style="overflow-y:hidden !important"
  :width="640"
  v-model="modalExportExcelPdf.activeModalExportExcelPdf"
  >
  <ModalExportExcelPdf :modalExportExcelPdf="modalExportExcelPdf"
  /></b-modal>
  <b-modal
  :width="640"
  v-model="modalExportColidee.activeModalExportColidee"
  >
  <ModalExportColidee :modalExportColidee="modalExportColidee"
  /></b-modal>
</div>
</div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import AddSondageButton from '@/components/button/AddSondageButton'
  import ParametersDropdown from '@/components/sondage/components/ParametersDropdown'
  import ModalQrCode from '@/components/sondage/components/ModalQrCode'
  import ModalShare from '@/components/sondage/components/ModalShare'
  import ModalDuplicate from '@/components/sondage/components/ModalDuplicate'
  import ModalExportExcelPdf from '@/components/sondage/components/ModalExportExcelPdf'
  import ModalExportColidee from '@/components/sondage/components/ModalExportColidee'
  import WhoIsOwner from '@/components/sondage/components/WhoIsOwner'
  import draggable from 'vuedraggable'

  export default {
    name: 'CardsList',
    components: {
      AddSondageButton,
      ParametersDropdown,
      ModalQrCode,
      ModalShare,
      ModalDuplicate,
      ModalExportExcelPdf,
      ModalExportColidee,
      WhoIsOwner,
      draggable
    },
    props: ['window'],
    data () {
      return {
        dragging: false,
        validateButtons: false
      }
    },
    watch: {
      getToastOrderedList: function () {
        if (this.getToastOrderedList) {
          this.$buefy.toast.open({
            type: 'is-success',
            message: this.$i18n.t('toast.updateOrderedList')
          })
          this.$store.commit('UPDATE_TOAST_ORDERED_LIST', false)
        }
      },
      getToastError: function () {
        if (this.getToastError) {
          this.$buefy.toast.open({
            type: 'is-danger',
            message: this.$i18n.t('toast.errorHasOccurred')
          })
          this.$store.commit('UPDATE_TOAST_ERROR', false)
        }
      }
    },
    updated () {
      this.$nextTick(function () {
        let message = {
          height: document.body.scrollHeight
        }
        window.top.postMessage(message, '*')
      })
    },
    mounted () {
      window.scrollTo(0, 0)
      this.sendMessageToParent('scrollToTop')
      this.$store.commit('CLEAR_FIELDS')
      this.$store.dispatch('getSondages')
      if (this.$store.state.sondage.search_query.length) {
        this.$store.commit('ADMIN_ACTIVE_COMPONENTS', {
          searchBar: true,
          cardList: true,
          parameters: false
        })
      }
    },
    computed: {
      ...mapGetters([
        'sondages_affiche',
        'modalQrCode',
        'modalShares',
        'modalDuplicate',
        'modalExportExcelPdf',
        'modalExportColidee',
        'getToastOrderedList',
        'getToastError',
        'getLoadingOrderedList'
        ]),
      now: function () {
        return new Date()
      },
      meetings: function () {
        return this.sondages_affiche
      }
    },
    methods: {
      showButtonsValidate () {
        this.validateButtons = true
      },
      cancelOrderedList () {
        this.validateButtons = false
      },
      validateOrderedList () {
        this.meetings.forEach((meeting, index) => {
          meeting.order = index
        })
        this.$store.dispatch('updateOrdersMeetingsList', this.meetings)
        this.validateButtons = false
      },
      sendMessageToParent (taskToDo) {
        let message = {
          task: taskToDo
        }
        window.top.postMessage(message, '*')
      },
      questions (sondageId, sondageName) {
        this.sendMessageToParent('scrollToTop')
        this.$store.commit('CONFIGURE_QUESTIONS_SONDAGE_NAME', sondageName)
        this.$store.commit('CONFIGURE_QUESTIONS_SONDAGE', sondageId)
        this.$router.push({ name: 'AdminQuestions' })
      },
      resultats (sondageUrlModerateur, sondageId, sondageName) {
        this.$store.commit('CONFIGURE_QUESTIONS_SONDAGE_NAME', sondageName)
        this.$store.commit('CONFIGURE_QUESTIONS_SONDAGE', sondageId)
        this.$router.push({
          name: 'resultats',
          params: { url_moderateur: sondageUrlModerateur }
        })
      },
      background (urlMedia) {
        if (urlMedia === null) {
          if (window.width < 480) {
          }
          return (
            'height:150px; width:100%; background-size: cover;background-position: center;background-image:url(' +
            require('@/assets/img/medaillonsondages.png') +
            ')'
            )
        } else {
          return (
            'height:150px; width:100%;background-size: cover;background-position: center;background-image:url(' +
            process.env.URL_MEDIA +
            urlMedia +
            ')'
            )
        }
      }
    }
  }
</script>
<style scoped>
  .sortable-chosen {
    background: white;
  }
  .ghost {
    opacity: 0.6;
  }
  .btn-primary {
    color: #fff;
    background-color: #424a60;
    border-color: #424a60;
    cursor: pointer;
  }
  .button {
    border-color: none;
    border-radius: 0px;
    font-size: 12px;
    height: 100%;
  }
  .button:hover {
    border-color: none;
    border-radius: 0px;
    font-size: 12px;
    height: 100%;
    text-decoration: none;
  }
  .button:disabled {
    border-color: none;
    color: currentColor;
    cursor: not-allowed;
    opacity: 0.5;
    text-decoration: none;
    font-size: 12px;
    height: 100%;
  }
  .shadow-card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  }
  .state-closed {
    opacity: 0.3;
  }
  .button-delete {
    padding: 5px 7px;
    background-color: #e6ecf0;
  }
  .button-delete:hover {
    background-color: red;
    color: white;
  }
  .button-params {
    padding: 5px 7px;
    background-color: #e6ecf0;
  }
  .button-params:hover {
    background-color: #424a60;
    color: white;
  }
  .text-resize-colidee {
    font-size: 10px;
  }
  .open {
    border-top: 2px solid green;
  }
  .over {
    border-top: 2px solid red;
  }
  #programmed-meeting {
    position: absolute;
    background: orange;
    right: 0px;
    top: 35px;
    padding: 1px 5px;
    color: #fff;
    font-size: 10px;
    width: auto;
  }
  #closed-meeting {
    position: absolute;
    background: #424A60;
    right: 0px;
    top: 35px;
    padding: 1px 5px;
    color: #fff;
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sondage/CardsList.vue